import { Address as AdminAddress, User as AdminUser } from '../../schema/admin';
import { Address as UserAddress, User as UserUser } from '../../schema/user';

import type { FormattingFn } from '.';

type Address = UserAddress | AdminAddress
type User = UserUser | AdminUser

type AddressType = Pick<Address, 'country' | 'region' | 'postalCode' | 'city' | 'streetLine'>;
const inlineAddress: FormattingFn<Partial<AddressType>> = () => (data) => [
  data.streetLine,
  [
    data.postalCode,
    data.city,
  ].filter(Boolean).join(' '),
  data.region,
  data.country,
].filter(Boolean).join(', ');

type UserType = Pick<User, 'firstName' | 'lastName' | 'middleName'>
const personFullName: FormattingFn<Partial<UserType>> = () => (data) => [
  data.firstName,
  [
    data.middleName,
  ].filter(Boolean).join(' '),
  data.lastName,
].filter(Boolean).join(' ');

const personalInfo = {
  inlineAddress,
  personFullName,
} as const;

export type PersonalInfo = typeof personalInfo;

export default personalInfo;
